<template>
  <HeadlessRadioGroup>
    <div
      class="flex flex-nowrap items-stretch justify-between space-x-1 rounded-md border border-background-fg/8 bg-background p-0.5"
    >
      <HeadlessRadioGroupOption as="template">
        <div
          :class="[
            modelValue ? 'bg-primary text-white' : '',
            'flex-1 cursor-pointer rounded-lg px-2 py-1 text-center text-sm',
          ]"
          @click="emit('update:modelValue', true)"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1"
          >
            {{ trueLabel }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
      <HeadlessRadioGroupOption as="template">
        <div
          :class="[
            !modelValue ? 'bg-primary text-white' : '',
            'flex-1 cursor-pointer rounded-lg px-2 py-1 text-center text-sm',
          ]"
          @click="emit('update:modelValue', false)"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1"
          >
            {{ falseLabel }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  trueLabel: string
  falseLabel: string
}>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: boolean): void
}>()
</script>
